import { call, takeLatest, put } from 'redux-saga/effects';
import apiRequest from '../api/api.request';
import endpoints from '../../../constants/endpoints';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import { getCoorporateProfile, setCoorporateProfile } from '../actions/CorporateProfileAction';

function* fetchGetProfileCorporate({
    payload,
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
    const config: ApiRequestConfig = {
		path: endpoints.api.COORPORATE_USER_PROFILE,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
    try {
		const res = yield call(apiRequest, config);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data } = res as any;
		yield put(setCoorporateProfile(data));
		return payload;
	} catch (err) {
		return err;
	}
}

export default function* coorporateProfileSaga(): Generator {
    yield takeLatest(getCoorporateProfile, fetchGetProfileCorporate);
}
